import styled from '@emotion/styled';
import { lighten } from 'polished';

import { StyledButton } from '../../UI/Button/Button.css';
import { mediaQueries, remCalc, font, palette } from '../../css';

const StyledDurationButton = styled('div')(() => ({
    width: '49%',
    marginBottom: '1%',

    '&:nth-child(even)': {
        marginLeft: '1%',
    },

    [mediaQueries.mediumLarge]: {
        width: remCalc(220),
        margin: remCalc(0, 15, 15, 0),

        '&:nth-child(even)': {
            marginLeft: 'inherit',
        },
    },
}));

const StyledSearchDurationFilter = styled('div')(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    flexDirection: 'row',

    [mediaQueries.mediumLarge]: {
        justifyContent: 'none',
    },

    [StyledButton]: {
        backgroundColor: lighten(0.1, palette('primary', 'mainNav')),
        width: '100%',
        minWidth: 'auto',
        fontWeight: font.weight.medium,

        [mediaQueries.mediumLarge]: {
            padding: remCalc(15, 0),
        },

        '&:hover': {
            backgroundColor: lighten(0.2, palette('primary', 'mainNav')),
        },
    },
}));

export { StyledSearchDurationFilter, StyledDurationButton };
